// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbu_a bhn_a bhn_q bhn_j bhn_wl bhn_bj","ImgResponsive__img":"bbu_b bhn_b bhn_ql"};